// ----------------------------------------------------------------------- imports externos
import { useEffect, useState } from "react";

// ----------------------------------------------------------------------- imports internos
import { telefonoDeChofer } from "../../services/documentacion";
import { aWhatsapp, elegir } from "../../shared/telefono";
import { useAvisarVacio } from "./BloqueFicha";

/* El teléfono de una persona, con las dos fuentes cruzadas.
 *
 * QUÉ RESUELVE. El padrón tiene `telefono` y casi siempre está vacío —65 de
 * 2.476—, así que la ficha de un chofer mostraba un hueco mientras el número
 * estaba escrito en la planilla de documentación, que se sincroniza sola todas
 * las noches y vive en la misma base. **176 personas ganan un teléfono** con
 * esto, sin que nadie cargue nada.
 *
 * LA REGLA DE CUÁL GANA NO VIVE ACÁ: está en `shared/telefono.js`, aparte y
 * probada en una tabla. Escrita en el componente, el día que el mismo cruce
 * haga falta en Documentos o en el alta de movimientos habría dos versiones y
 * el hub diría dos cosas del mismo número.
 *
 * Y LA DISCREPANCIA SE MUESTRA. Hay una sola persona donde el padrón y la
 * planilla dicen números distintos. Elegir en silencio deja al que llama sin
 * saber que había otro para probar.
 *
 * NO FRENA NADA. Mientras no llegó se dibuja lo que ya se sabe del padrón: la
 * ficha tiene que abrir aunque la planilla no conteste.
 */
const Telefono = ({ dni, delPadron }) => {
  // undefined = todavía no llegó · null = no se pudo mirar · "" = no hay fila
  const [dePlanilla, setDePlanilla] = useState(undefined);

  useEffect(() => {
    let vigente = true;
    telefonoDeChofer(dni)
      .then((t) => vigente && setDePlanilla(t))
      .catch(() => vigente && setDePlanilla(null));
    return () => {
      vigente = false;
    };
  }, [dni]);

  const cargando = dePlanilla === undefined;
  const fallo = dePlanilla === null;
  const t = elegir({ padron: delPadron, planilla: fallo ? "" : dePlanilla });

  /* Sin nada escrito y sin nada que consultar, la línea no aparece. Un
   * «Teléfono —» en las 2.100 personas que no manejan es ruido que hace que
   * el hueco de las que sí importan no se note.
   *
   * Y en la ficha de la persona se lo dice a su bloque, que si no quedaba un
   * recuadro «Teléfono» sin nada adentro: el mismo ruido, con borde. */
  const sinNada = !t.crudo && !cargando && !fallo;
  useAvisarVacio(cargando ? undefined : sinNada);
  if (sinNada) return null;

  const link = aWhatsapp(t.crudo);

  return (
    <div className="ficha-telefono">
      <span className="et">Teléfono</span>
      <span className="ficha-telefono-txt">
        {link ? (
          <a href={link} target="_blank" rel="noreferrer">
            {t.crudo}
          </a>
        ) : (
          <b>{t.crudo || "—"}</b>
        )}
        {/* De dónde salió. Sin esto, el número de la planilla se lee como si
            alguien lo hubiera cargado en el padrón, y el día que esté mal se
            va a corregir en la pantalla que no es. */}
        {t.fuente === "planilla" && (
          <span className="ficha-telefono-fuente"> · de documentación</span>
        )}
      </span>

      {/* UN NÚMERO MAL TIPEADO NO SE DIBUJA COMO UNO QUE FALTA. El que falta se
          pide; éste se corrige, y son dos trabajos distintos. */}
      {t.ilegible && (
        <span className="ficha-telefono-nota">
          No se entiende el número.
        </span>
      )}

      {/* La discrepancia se MUESTRA y no se resuelve: misma regla que el cotejo
          del chofer y que los mecánicos parecidos. */}
      {t.discrepancia && (
        <span className="ficha-telefono-nota">
          El padrón tiene otro: <b>{t.discrepancia}</b>.
        </span>
      )}

      {/* «No pude mirar» no se dice como «no tiene». */}
      {fallo && (
        <span className="ficha-telefono-nota">
          No se pudo consultar.
        </span>
      )}
    </div>
  );
};

export default Telefono;
